document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCountUp();
  initMarqueeSpeed();
  initGaleriaProducto();
  initVariantesProducto();
  initUrgenciaViendo();
  initContadorOferta();
});

function initContadorOferta() {
  document.querySelectorAll('[data-mt-contador]').forEach(function (el) {
    if (el.getAttribute('data-mt-contador-init')) return;
    el.setAttribute('data-mt-contador-init', '1');
    var horas = parseFloat(el.getAttribute('data-horas') || '24');
    var clave = el.getAttribute('data-clave') || 'mt_contador_default';
    var duracionMs = horas * 60 * 60 * 1000;

    var hEl = el.querySelector('[data-mt-h]');
    var mEl = el.querySelector('[data-mt-m]');
    var sEl = el.querySelector('[data-mt-s]');
    if (!hEl || !mEl || !sEl) return;

    function leerExpiracion() {
      var guardado = null;
      try { guardado = window.localStorage.getItem(clave); } catch (e) {}
      var expira = guardado ? parseInt(guardado, 10) : 0;
      if (!expira || expira <= Date.now()) {
        expira = Date.now() + duracionMs;
        try { window.localStorage.setItem(clave, String(expira)); } catch (e) {}
      }
      return expira;
    }

    var expira = leerExpiracion();

    function pad(n) { return String(n).padStart(2, '0'); }

    function actualizar() {
      var restante = expira - Date.now();
      if (restante <= 0) {
        expira = leerExpiracion();
        restante = expira - Date.now();
      }
      var totalSeg = Math.floor(restante / 1000);
      var h = Math.floor(totalSeg / 3600);
      var m = Math.floor((totalSeg % 3600) / 60);
      var s = totalSeg % 60;
      hEl.textContent = pad(h);
      mEl.textContent = pad(m);
      sEl.textContent = pad(s);
    }

    actualizar();
    setInterval(actualizar, 1000);
  });
}

function initUrgenciaViendo() {
  document.querySelectorAll('[data-mt-viendo]').forEach(function (el) {
    if (el.getAttribute('data-mt-viendo-init')) return;
    el.setAttribute('data-mt-viendo-init', '1');
    var textoEl = el.querySelector('.mt-urgencia__viendo-texto');
    if (!textoEl) return;
    var min = parseInt(el.getAttribute('data-min') || '8', 10);
    var max = parseInt(el.getAttribute('data-max') || '34', 10);
    var plantilla = el.getAttribute('data-texto') || '{n} personas están viendo este producto ahora mismo';
    function actualizar() {
      var n = Math.floor(Math.random() * (max - min + 1)) + min;
      textoEl.textContent = plantilla.replace('{n}', n);
    }
    actualizar();
    setInterval(actualizar, 20000);
  });
}

function initGaleriaProducto() {
  document.querySelectorAll('.mt-producto').forEach(function (root) {
    var main = root.querySelector('.mt-galeria__principal img');
    var thumbs = root.querySelectorAll('.mt-galeria__thumb');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (!full) return;
        main.src = full;
        main.alt = thumb.getAttribute('data-alt') || main.alt;
        thumbs.forEach(function (t) { t.classList.remove('mt-galeria__thumb--activo'); });
        thumb.classList.add('mt-galeria__thumb--activo');
      });
    });
  });
}

function initVariantesProducto() {
  document.querySelectorAll('.mt-producto').forEach(function (root) {
    var dataEl = root.querySelector('[data-variantes-json]');
    var idInput = root.querySelector('input[name="id"]');
    var precioEl = root.querySelector('.mt-producto__precio-actual');
    var compareEl = root.querySelector('.mt-producto__precio-tachado');
    var submitBtn = root.querySelector('.mt-producto__comprar');
    var selects = root.querySelectorAll('.mt-producto__opcion');
    if (!dataEl || !idInput || !selects.length) return;

    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

    function moneyFmt(cents) {
      return (cents / 100).toLocaleString(document.documentElement.lang || 'es', { style: 'currency', currency: root.getAttribute('data-moneda') || 'USD' });
    }

    function actualizar() {
      var seleccion = Array.prototype.map.call(selects, function (s) { return s.value; });
      var variante = variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === seleccion[i]; });
      });
      if (!variante) return;
      idInput.value = variante.id;
      if (precioEl) precioEl.textContent = moneyFmt(variante.price);
      if (compareEl) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          compareEl.textContent = moneyFmt(variante.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !variante.available;
        submitBtn.textContent = variante.available ? submitBtn.getAttribute('data-texto-disponible') : submitBtn.getAttribute('data-texto-agotado');
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  });
}

function initReveal() {
  var items = document.querySelectorAll('.mt-reveal');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  items.forEach(function (el, i) {
    el.style.setProperty('--mt-delay', Math.min(i % 6, 5) * 0.08 + 's');
    observer.observe(el);
  });
}

function initCountUp() {
  var els = document.querySelectorAll('.mt-countup');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      observer.unobserve(el);
      var target = parseFloat(el.getAttribute('data-target') || '0');
      var suffix = el.getAttribute('data-suffix') || '';
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var value = target * eased;
        el.textContent = (target % 1 === 0 ? Math.round(value) : value.toFixed(1)) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}

function initMarqueeSpeed() {
  document.querySelectorAll('.mt-marquee').forEach(function (wrap) {
    var track = wrap.querySelector('.mt-marquee__track');
    var speed = wrap.getAttribute('data-speed');
    if (track && speed) track.style.setProperty('--mt-marquee-duration', speed + 's');
  });
}
